import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "./errorMessage";
import Validator from "./validator";

export interface NnwClientsSubtractionCountModel {
  value: number;
  errorMessage: string;

  validateNnwClientSubstraction: () => void;
}

interface DefaultNnwClientsSubtractionCountArguments {
  value: number;
  errorMessage: string;
}

export class DefaultNnwClientsSubtractionCount implements NnwClientsSubtractionCountModel {
  @observable value = 0;
  @observable errorMessage = "";

  constructor(args?: DefaultNnwClientsSubtractionCountArguments) {
    makeObservable(this);

    this.value = args?.value !== undefined ? args.value : 0;
    this.errorMessage = "";
  }

  @action
  public validateNnwClientSubstraction = () => {
    if (!Validator.isNumberOfNnwClientsValid(this.value)) {
      this.errorMessage = ErrorMessages.nnw.invalidNumber;
    } else if (!Validator.isHeartAttackAndStrokeAvailable(this.value!)) {
      this.errorMessage = ErrorMessages.nnw.invalidHeartAttackAndStrokeInsuredsCount;
    } else {
      this.errorMessage = "";
    }
  }
}
